import { useIntl } from 'react-intl';
import { Col, Input, Row } from 'antd';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import { CompaniesInfiniteSelectField } from '@/components/_common';
import { NumberInutilizationRequest } from '@/core/domain/invoice/numberInutilization/numberInutilization.types';

type Props = ExtraFiltersProps<NumberInutilizationRequest>;

function DisableNumberExtraFilters(props: Props) {
  const intl = useIntl();

  return (
    <Row gutter={[24, 24]}>
      <Col xs={24} sm={24} md={12} lg={6}>
        <CompaniesInfiniteSelectField
          value={props.queryParams?.companyId}
          allowClear
          onChange={(value) => {
            props.setQueryParams((prev) => ({ ...prev, companyId: value }));
          }}
          placeholder={intl.formatMessage({
            id: 'invoice.disableNumberingRange.filter.company',
          })}
        />
      </Col>

      <Col xs={24} sm={24} md={12} lg={6}>
        <Input
          value={props.queryParams?.startNumber}
          onChange={({ target }) => {
            props.setQueryParams((prev) => ({
              ...prev,
              startNumber: Number(target.value),
            }));
          }}
          placeholder="Numeração inicial"
        />
      </Col>

      <Col xs={24} sm={24} md={12} lg={6}>
        <Input
          value={props.queryParams?.endNumber}
          onChange={({ target }) => {
            props.setQueryParams((prev) => ({
              ...prev,
              endNumber: Number(target.value),
            }));
          }}
          placeholder="Numeração final"
        />
      </Col>
    </Row>
  );
}

export default DisableNumberExtraFilters;
